module.exports = __webpack_public_path__ + "img/img3.3db8b588.jpg";